import React, { useState, useEffect } from 'react';
import { Modal, Button, Card } from 'react-bootstrap';
import { BASE_URL } from './../../../config';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import { FaTrash, FaCloudUploadAlt } from 'react-icons/fa'; // Íconos para eliminar y cargar

const ModalImagenesTorneoComponet = () => {
  const [showModal, setShowModal] = useState(false);
  const [files, setFiles] = useState([]);
  const [albumImages, setAlbumImages] = useState([]);

  const fetchAlbumImages = async () => {
    try {
      const response = await fetch(`${BASE_URL}images`);
      const data = await response.json();
      setAlbumImages(data);
    } catch (error) {
      toast.error('Error al obtener las imágenes');
      console.error('Error al obtener las imágenes:', error);
    }
  };

  useEffect(() => {
    fetchAlbumImages();
  }, []);

  const handleImageChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    setFiles(prevFiles => prevFiles.concat(selectedFiles));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('images[]', file);
    });

    try {
      const response = await fetch(`${BASE_URL}store-images`, {
        method: 'POST',
        body: formData,
      });
      if (response.ok) {
        toast.success('Imágenes cargadas con éxito');
        fetchAlbumImages();
        setFiles([]);
      } else {
        toast.error('Error al cargar las imágenes');
        console.error('Error al cargar imágenes');
      }
    } catch (error) {
      toast.error('Error en el servidor');
      console.error('Error:', error);
    }
    
    setShowModal(false);
  };

  const handleDeleteImage = async (id) => {
    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción eliminará la imagen permanentemente.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(`${BASE_URL}images/${id}`, {
          method: 'DELETE',
        });

        if (response.ok) {
          toast.success('Imagen eliminada con éxito');
          fetchAlbumImages();
        } else {
          toast.error('Error al eliminar la imagen');
          console.error('Error al eliminar la imagen');
        }
      } catch (error) {
        toast.error('Error en el servidor');
        console.error('Error:', error);
      }
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setFiles([]);
  };

  return (
    <div style={{ padding: '20px' }}>
      <Button variant="outline-primary" onClick={() => setShowModal(true)} style={{ marginBottom: '20px' }}>
        <FaCloudUploadAlt /> Cargar Imágenes
      </Button>

      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Cargar Imágenes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="file"
            accept="image/*"
            multiple
            onChange={handleImageChange}
            style={{ marginBottom: '10px' }}
          />
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))', gap: '10px', marginTop: '10px' }}>
            {files.map((file, index) => (
              <img
                key={index}
                src={URL.createObjectURL(file)}
                alt={`Preview ${index}`}
                style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
              />
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cerrar
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Cargar Imágenes
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />

      <h2>Álbum de Imágenes</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '15px', marginTop: '20px' }}>
        {albumImages.length > 0 ? (
          albumImages.map(image => (
            <Card key={image.id} style={{ position: 'relative', borderRadius: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
              <Card.Img variant="top" src={image.urlImage} style={{ borderRadius: '10px 10px 0 0' }} />
              <Button
                variant="danger"
                onClick={() => handleDeleteImage(image.id)}
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  padding: '5px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <FaTrash />
              </Button>
            </Card>
          ))
        ) : (
          <p>No hay imágenes cargadas.</p>
        )}
      </div>
    </div>
  );
};

export default ModalImagenesTorneoComponet;
